import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-product-nature.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetProductNatureDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metProductNatureEntity = useAppSelector(state => state.metProductNature.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metProductNatureDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metProductNature.detail.title">MetProductNature</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metProductNatureEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metProductNature.code">Code</Translate>
            </span>
          </dt>
          <dd>{metProductNatureEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metProductNature.name">Name</Translate>
            </span>
          </dt>
          <dd>{metProductNatureEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metProductNature.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{metProductNatureEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metProductNature.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{metProductNatureEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metProductNature.status">Status</Translate>
            </span>
          </dt>
          <dd>{metProductNatureEntity.status}</dd>
          <dt>
            <Translate contentKey="almobadaraMasterDataApp.metProductNature.typeProductNature">Type Product Nature</Translate>
          </dt>
          <dd>{metProductNatureEntity.typeProductNature ? metProductNatureEntity.typeProductNature.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/met-product-nature" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-product-nature/${metProductNatureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetProductNatureDetail;
